import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: "https://2d386e6866e1c5b1563d3dccf1ad38cc@o4511157492318208.ingest.de.sentry.io/4511157496578128",
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: false,
});

createRoot(document.getElementById("root")!).render(<App />);
